import { useState } from 'react'
import classNames from 'classnames'

import { QA_CONTEXT_PAGE, QA_PAGE_KEY } from '../../../constants/qa'
import { PageSidePanelContainer } from '../../../context'
import { useLayoutOverlayContext } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { ErrorPage } from '../../ErrorPage'
import { PageWidgetsContainer } from '../../Widget'
import { PageFooter } from '../PageFooter'

import * as styles from './PageWithWidgets.module.css'

function PageWithWidgets({
  Footer = PageFooter,
  children,
  className = styles.PageWithWidgets,
  contentClassName = styles.content,
  isWidgetsHidden = false,
  qaName,
  scrollWrapperClassName = styles.scrollWrapper,
  scrollWrapperRef,
  serverError,
  widgets,
  widgetsClassName = styles.widgetsWrapper,
  widgetsFlexible,
}) {
  const [sidePanelContainer, setSidePanelContainer] = useState(null)

  const { showGretaAIChat, showProductFruits, withModalsTray } =
    useLayoutOverlayContext()

  const qaProps = getQaSelector(
    { context: QA_CONTEXT_PAGE, value: qaName },
    QA_PAGE_KEY
  )

  const pageWithWidgetsClassName = classNames(className, {
    [styles.widgetsFlexible]: widgetsFlexible,
  })

  const widgetsContainerClassName = classNames(
    {
      [styles.widgetsHidden]: isWidgetsHidden,
      [styles.withModalsTray]: withModalsTray,
      [styles.withSupportButtons]: showGretaAIChat || showProductFruits,
    },
    widgetsClassName
  )

  const scrollWrapperClassNameWithOverlay = classNames(scrollWrapperClassName, {
    [styles.withModalsTray]: withModalsTray,
    [styles.withSupportButtons]: showProductFruits,
  })

  return serverError ? (
    <ErrorPage status={serverError.status} />
  ) : (
    <div {...qaProps} className={pageWithWidgetsClassName}>
      <PageSidePanelContainer value={sidePanelContainer}>
        <div className={styles.contentWrapper}>
          <div
            className={scrollWrapperClassNameWithOverlay}
            ref={scrollWrapperRef}
          >
            <div className={contentClassName}>{children}</div>
            {Footer ? <Footer /> : null}
          </div>
          {widgets ? (
            <PageWidgetsContainer className={widgetsContainerClassName}>
              {widgets}
            </PageWidgetsContainer>
          ) : null}
          <div className={styles.sidePanel} ref={setSidePanelContainer} />
        </div>
      </PageSidePanelContainer>
    </div>
  )
}

export default PageWithWidgets
